import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse("DFSW5SN7mkjM9RtNVldCRinIYnZR92EF");
const IV = CryptoJS.enc.Utf8.parse("KE1RTKZ6oxsFWgXA");

export function decryptConfig(encryptedText) {
  if (!encryptedText) return null;

  try {
    // 1️⃣ Decode URL-safe string
    const decoded = decodeURIComponent(encryptedText);

    // 2️⃣ AES decrypt
    const bytes = CryptoJS.AES.decrypt(decoded, KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // 3️⃣ Convert to UTF-8 string
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
      throw new Error("Empty decrypted text");
    }

    // 4️⃣ Parse JSON ONCE
    return JSON.parse(decryptedText);

  } catch (err) {
    console.error("decryptConfig error:", err);
    return null;
  }
}
